module.exports = __webpack_public_path__ + "static/p14_gallinita-12981bb244149f6b7647dd59acdc6fbc.png";